var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHiringworker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 185,
    height: 129,
    viewBox: "0 0 185 129",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Task_Card",
    "data-name": "Task Card",
    transform: "translate(-994 -278)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1795",
    "data-name": "Rectangle 1795",
    width: 185,
    height: 129,
    rx: 8,
    transform: "translate(994 278)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1809",
    "data-name": "Rectangle 1809",
    d: "M0,0H62a8,8,0,0,1,8,8V121a8,8,0,0,1-8,8H0a0,0,0,0,1,0,0V0A0,0,0,0,1,0,0Z",
    transform: "translate(1109 278)",
    fill: "#e4edfa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1798",
    "data-name": "Rectangle 1798",
    width: 54,
    height: 12,
    rx: 4,
    transform: "translate(1117 321)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1894",
    "data-name": "Rectangle 1894",
    width: 54,
    height: 12,
    rx: 4,
    transform: "translate(1117 303)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1890",
    "data-name": "Rectangle 1890",
    width: 88,
    height: 12,
    rx: 4,
    transform: "translate(1009 321)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1893",
    "data-name": "Rectangle 1893",
    width: 88,
    height: 12,
    rx: 4,
    transform: "translate(1009 303)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1891",
    "data-name": "Rectangle 1891",
    width: 88,
    height: 12,
    rx: 4,
    transform: "translate(1009 339)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1892",
    "data-name": "Rectangle 1892",
    width: 88,
    height: 12,
    rx: 4,
    transform: "translate(1009 357)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1800",
    "data-name": "Rectangle 1800",
    width: 54,
    height: 12,
    rx: 4,
    transform: "translate(1117 339)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1801",
    "data-name": "Rectangle 1801",
    width: 54,
    height: 12,
    rx: 4,
    transform: "translate(1117 357)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1802",
    "data-name": "Rectangle 1802",
    transform: "translate(1117 375)",
    fill: "none",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeWidth: 1,
    strokeDasharray: 6
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 12,
    rx: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 53,
    height: 11,
    rx: 3.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1895",
    "data-name": "Rectangle 1895",
    transform: "translate(1009 375)",
    fill: "none",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeWidth: 1,
    strokeDasharray: 6
  }, /*#__PURE__*/React.createElement("rect", {
    width: 88,
    height: 12,
    rx: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 87,
    height: 11,
    rx: 3.5,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHiringworker);
export default __webpack_public_path__ + "static/media/hiringworker.64f039ba8b9e8f46588799f7f7b9c544.svg";
export { ForwardRef as ReactComponent };